class TestimonialsCarousel {
    constructor(element) {
        this.element = element;
        this.swiperElement = element.querySelector('[data-testimonials-swiper]');
        this.prevButton = element.querySelector('.testimonials-arrow--prev');
        this.nextButton = element.querySelector('.testimonials-arrow--next');
        this.swiperInstance = null;

        this.init();
    }

    init() {
        if (!this.swiperElement) return;

        this.createSwiper();
        this.handleResize();
    }

    createSwiper() {
        const options = {
            slidesPerView: 1,
            spaceBetween: 0,
            loop: true,
            grabCursor: true,
            centeredSlides: true,
            navigation: {
                nextEl: this.nextButton,
                prevEl: this.prevButton,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                768: {
                    slidesPerView: 3.4,
                    spaceBetween: 20,
                },
            },
        };

        this.swiperInstance = new Swiper(this.swiperElement, options);
    }

    handleResize() {
        let resizeTimer;
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
                if (this.swiperInstance) {
                    this.swiperInstance.update();
                }
            }, 250);
        });
    }

    destroy() {
        if (this.swiperInstance) {
            this.swiperInstance.destroy(true, true);
            this.swiperInstance = null;
        }
    }
}

// Initialize
document.addEventListener('DOMContentLoaded', () => {
    const carousels = document.querySelectorAll('.testimonials-carousel-section');
    carousels.forEach(carousel => new TestimonialsCarousel(carousel));
});

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
        const carousel = event.target.querySelector('.testimonials-carousel-section');
        if (carousel) new TestimonialsCarousel(carousel);
    });

    document.addEventListener('shopify:section:unload', (event) => {
        const carouselElement = event.target.querySelector('.testimonials-carousel-section');
        if (carouselElement && carouselElement._testimonialsCarousel) {
            carouselElement._testimonialsCarousel.destroy();
        }
    });
}